import dayjs, { Dayjs } from 'dayjs'
import { useEffect, useState } from 'react';
import { Text, TextStyle, View } from 'react-native';
type Props = {
  dateDebut: string | Date | Dayjs,
  dateFin: string | Date | Dayjs,
  heureDebut?: number,
  heureFin?: number,
  direction?: 'row' | 'column'
  style?: TextStyle,
}
export function AffichagePeriode({dateDebut, dateFin, heureDebut, heureFin, direction = 'row', style}: Props){
  const [debut, setDebut] = useState(dayjs(dateDebut));
  const [fin, setFin] = useState(dayjs(dateFin));
  const [format, setFormat] = useState('DD/MM/YYYY');
  useEffect(() => {
    if(heureDebut && heureFin){
      setDebut((old) => old.hour(heureDebut).minute(Math.round((heureDebut % 1) * 100)))
      setFin((old) => old.hour(heureFin).minute(Math.round((heureFin % 1) * 100)))
      setFormat('DD/MM/YYYY HH:mm')
    } else {
      setDebut(dayjs(dateDebut))
      setFin(dayjs(dateFin))
      setFormat('DD/MM/YYYY')
    }
  }, [dateDebut, dateFin, heureDebut, heureFin])


  return (
    <View style={{flexDirection: direction, flexWrap: 'wrap'}}>
      <Text style={style}>Du {debut.format(format)} </Text>
      <Text style={style}>au {fin.format(format)}</Text>
    </View>
  )
}
